function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useContext } from 'react';
import Modal from "../modal";
import Typography from "../typography";
import Checkbox from "../checkbox";
import Button from "../button";
import LocaleContext from "../locale/locale-context";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Confirmation = function Confirmation(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    message = _ref.message,
    modalContent = _ref.modalContent,
    modalTitle = _ref.modalTitle,
    okText = _ref.okText,
    cancelText = _ref.cancelText,
    href = _ref.href;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  var handleCheckbox = function handleCheckbox(e) {
    e.stopPropagation();
    var checked = e.target.checked;
    if (!modalContent) {
      return onChange && onChange(checked || undefined);
    }
    if (!value) {
      setVisible(true);
    } else {
      onChange && onChange(undefined);
    }
  };
  var handleAccept = function handleAccept() {
    setVisible(false);
    onChange && onChange(true);
  };
  var handleReject = function handleReject() {
    setVisible(false);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Checkbox, {
      onChange: handleCheckbox,
      checked: value
    }), /*#__PURE__*/_jsx(Typography, {
      level: "body1",
      onClick: function onClick(e) {
        e.stopPropagation();
        if (modalContent) {
          return setVisible(true);
        }
        if (href) {
          var a = document.createElement('a');
          a.href = href;
          a.target = '_blank';
          a.click();
          return;
        }
        onChange && onChange(!value || undefined);
      },
      style: {
        cursor: 'pointer',
        marginLeft: 8
      },
      children: message || /*#__PURE__*/_jsxs(_Fragment, {
        children: [formatMessage({
          id: 'I agree to the Igloo'
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          href: "https://contents.iglooinsure.com/termsofservice",
          target: '_blank',
          style: {
            margin: '0 4px',
            lineHeight: 'inherit'
          },
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          children: formatMessage({
            id: 'Terms of Use'
          })
        }), formatMessage({
          id: 'and'
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          href: "https://contents.iglooinsure.com/privacypolicy",
          style: {
            margin: '0 4px',
            lineHeight: 'inherit'
          },
          target: '_blank',
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          children: formatMessage({
            id: 'Privacy Policy'
          })
        })]
      })
    }), modalContent && /*#__PURE__*/_jsx(Modal, {
      title: modalTitle,
      open: visible,
      onOk: handleAccept,
      onCancel: handleReject,
      footer: value ? null : undefined,
      okText: okText || formatMessage({
        id: 'Accept'
      }),
      cancelText: cancelText || formatMessage({
        id: 'Reject'
      }),
      children: modalContent
    })]
  });
};
Confirmation.formItemPropsHandler = function (config) {
  return {
    fullRow: true
  };
};
export default Confirmation;